module.exports = __webpack_public_path__ + "img/square_selected.3c9cf800.png";